import React from "react";
import _ from "lodash";

import { useDispatch, useSelector } from "react-redux";

import { css } from "@emotion/react";

import { Modal, type ModalProps } from "semantic-ui-react";

import { toggleModalState } from "../containers/App/App.slice";


interface ModalProviderProps extends ModalProps {
  id: string;
  defaultOpen?: boolean;
  closeIcon?: boolean;
  children: React.ReactNode;
  onOpen?: (event: React.MouseEvent<HTMLElement>, data: ModalProps) => void;
  onClose?: (event: React.MouseEvent<HTMLElement>, data: ModalProps) => void;
}


const styles = css({
  alignSelf: "center",
  ".header": {
    textAlign: "center"
  },
  ".close": {
    top: ".5rem !important",
    right: ".5rem !important",
    color: "rgba(0,0,0,.87) !important"
  }
});


export default function ModalProvider({
  id,
  children,
  defaultOpen,
  onOpen,
  onClose,
  ...rest
}: ModalProviderProps) {

  const dispatch = useDispatch();
  const modalStateFromStore = useSelector(state => _.get(state, "app.modalState", {}));

  const handleOnOpen = (event: React.MouseEvent<HTMLElement>, data: ModalProps) => {
    onOpen?.(event, data);
    dispatch(toggleModalState(id, true));
  };

  const handleOnClose = (event: React.MouseEvent<HTMLElement>, data: ModalProps) => {
    onClose?.(event, data);
    dispatch(toggleModalState(id, false));
  };

  const isOpen = _.defaultTo(modalStateFromStore[id], defaultOpen);

  return (
    <Modal
      id={id}
      css={styles}
      {...rest}
      open={isOpen}
      onOpen={handleOnOpen}
      onClose={handleOnClose}>
      {children}
    </Modal>
  );
}
